import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=c3276718&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports